import React from 'react';
import { Plus, Copy, Trash2, MoveUp, MoveDown } from 'lucide-react';
import { useLessonBuilderStore } from '../../stores/lessonBuilderStore';

export const PageRail: React.FC = () => {
  const pages = useLessonBuilderStore((s) => s.pages);
  const selectedPageId = useLessonBuilderStore((s) => s.selectedPageId);
  const selectPage = useLessonBuilderStore((s) => s.selectPage);
  const addPage = useLessonBuilderStore((s) => s.addPage);
  const duplicatePage = useLessonBuilderStore((s) => s.duplicatePage);
  const deletePage = useLessonBuilderStore((s) => s.deletePage);
  const movePage = useLessonBuilderStore((s) => s.movePage);

  return (
    <div className="w-64 flex-shrink-0 border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-4 space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Pages</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400">Tap to switch</p>
        </div>
        <button
          className="p-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
          onClick={() => addPage()}
          title="Add page"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>

      <div className="space-y-2">
        {pages.map((page, idx) => {
          const selected = page.id === selectedPageId;
          return (
            <div
              key={page.id}
              className={`border rounded-xl px-3 py-2 cursor-pointer transition ${
                selected ? 'border-blue-500 bg-blue-50 dark:border-blue-400/70 dark:bg-blue-900/40' : 'border-gray-200 dark:border-gray-800'
              }`}
              onClick={() => selectPage(page.id)}
            >
              <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
              <div className="text-sm font-semibold text-gray-900 dark:text-gray-50 truncate">
                {page.title || `Page ${idx + 1}`}
              </div>
              <div className="text-[11px] text-gray-500 dark:text-gray-400">
                {`Step ${idx + 1}`} {page.duration_hint ? `• ~${page.duration_hint}s` : ''}
                {page.cta_label ? ` • CTA: ${page.cta_label}` : ''}
                {page.is_intro ? ' • Intro' : ''}
                {page.is_summary ? ' • Summary' : ''}
              </div>
            </div>
                <div className="flex items-center gap-1">
                  <button
                    className="p-1 text-gray-400 hover:text-gray-700 dark:text-gray-500 dark:hover:text-gray-200"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (idx > 0) movePage(idx, idx - 1);
                    }}
                    title="Move up"
                  >
                    <MoveUp className="w-4 h-4" />
                  </button>
                  <button
                    className="p-1 text-gray-400 hover:text-gray-700 dark:text-gray-500 dark:hover:text-gray-200"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (idx < pages.length - 1) movePage(idx, idx + 1);
                    }}
                    title="Move down"
                  >
                    <MoveDown className="w-4 h-4" />
                  </button>
                  <button
                    className="p-1 text-gray-400 hover:text-gray-700 dark:text-gray-500 dark:hover:text-gray-200"
                    onClick={(e) => {
                      e.stopPropagation();
                      duplicatePage(page.id);
                    }}
                    title="Duplicate page"
                  >
                    <Copy className="w-4 h-4" />
                  </button>
                  <button
                    className="p-1 text-red-500 hover:text-red-700"
                    onClick={(e) => {
                      e.stopPropagation();
                      deletePage(page.id);
                    }}
                    title="Delete page"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          );
        })}
        {pages.length === 0 && (
          <div className="text-xs text-gray-500 dark:text-gray-400">No pages yet. Add one to start.</div>
        )}
      </div>
    </div>
  );
};
